import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface SidebarExitGuardDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

export function SidebarExitGuardDialog({
  open,
  onOpenChange,
  onConfirm,
}: SidebarExitGuardDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-3xl" data-testid="sidebar-exit-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-2xl font-normal leading-[1.2] tracking-[-0.48px] text-foreground dark:text-white">
            Leave this study?
          </AlertDialogTitle>
          <AlertDialogDescription className="text-base leading-[1.6] text-muted-foreground">
            Any progress you have not saved will be lost.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            className="rounded-full"
            data-testid="sidebar-exit-dialog-cancel"
          >
            Keep editing
          </AlertDialogCancel>
          <AlertDialogAction
            className="rounded-full bg-destructive text-destructive-foreground hover:bg-destructive/90"
            data-testid="sidebar-exit-dialog-confirm"
            onClick={(event) => {
              event.preventDefault()
              onConfirm()
            }}
          >
            Leave
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
